import { render } from "./TheFooter.vue?vue&type=template&id=3f55e46c&ts=true"
import script from "./TheFooter.vue?vue&type=script&lang=ts"
export * from "./TheFooter.vue?vue&type=script&lang=ts"

import "./TheFooter.vue?vue&type=style&index=0&id=3f55e46c&lang=css"

import exportComponent from "/Users/mufeng/Documents/ProjectWorkbench/hotaru_theme/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__